<template>
    <div>
        <v-card-title>{{$t('HelpProposal.page_current_state')}}</v-card-title>
        <v-card-subtitle>{{$t('HelpProposal.information_interface')}}</v-card-subtitle>
         <v-img
        max-width="600"
        src="../../../assets/help-proposal/Screenshot_8.png"></v-img>
    </div>
</template>
<script>
export default {
    name: 'ProposalHelp'
}
</script>